import { useCopyToClipboard as useCopyToClipboardFromReactUse } from "react-use";

export const useCopyToClipboard = () => {
	const [copyText, copy] = useCopyToClipboardFromReactUse();

	return { copyText, copy };
};
